export default ({ currencyCode,  products = [] }) => {
  return {
    event: 'removeFromCart',
    ecommerce: {
      currencyCode: currencyCode,
      remove: {
        products: products,
      },
    },
  };
};
